import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import Card from '@/components/Card'
import useFeatures from '@/components/useFeatures'

import messages from './messages'

type FeatureToggleProps = {
  children: ReactNode
  feature: string
  showComingSoon?: boolean
}

function FeatureToggle(props: FeatureToggleProps) {
  const features = useFeatures()

  if (features[props.feature]) {
    return props.children
  } else if (props.showComingSoon) {
    return (
      <Card className="default-disabled">
        <Card.Header title={<FormattedMessage {...messages.comingSoon} />} />
      </Card>
    )
  }

  return null
}

export default FeatureToggle
